import { render } from "./AnswerPopContainer.vue?vue&type=template&id=3c131657&scoped=true&ts=true"
import script from "./AnswerPopContainer.vue?vue&type=script&lang=ts"
export * from "./AnswerPopContainer.vue?vue&type=script&lang=ts"

import "./AnswerPopContainer.vue?vue&type=style&index=0&id=3c131657&lang=scss&scoped=true"

import exportComponent from "/data/.jenkins/workspace/k8s-shouba-exhibitionhall-h5-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c131657"]])

export default __exports__